import { Pipe, PipeTransform } from '@angular/core';
import { NamedRoutesService } from "ng-named-routes";

@Pipe({
  name: 'getRoute'
})
export class GetRoutePipe implements PipeTransform {

  constructor(private namedRoutesService: NamedRoutesService) {}

  transform(name: string, params?: any): any {
    return '/' + this.namedRoutesService.getRoute(name, params);
  }

}
